import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(null);
  const load = useCallback(async () => {
    const { data } = await api.get("/public/site");
    setSite(data);
  }, []);
  useEffect(() => { load().catch(() => setSite(false)); }, [load]);
  return <SiteCtx.Provider value={{ site, reload: load }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export function useCompany() {
  const { site } = useSite();
  return site?.settings?.company || {};
}
